// semeia-disable-reexport
import type {
  ComputedAlertType,
  HomePageAlertType,
  PrescriptionTrigger,
  TlsPrescriptionTrigger
} from "parog-web/models/alert-triggered-journal-event";

export function isTlsPrescriptionAlert(alert: HomePageAlertType): boolean {
  return computeAlertType(alert) === "tls-prescription";
}

export function computeAlertType(
  alert: HomePageAlertType
): ComputedAlertType | undefined {
  if (
    alert.alertType === "journey" &&
    alert.subType === "tls-prescription" &&
    alert.triggers.length > 0 &&
    alert.triggers?.[0]?.type === "expiration"
  )
    return "tls-prescription";
  else if (
    alert.alertType === "journey" &&
    alert.subType === "bio-exam-prescription" &&
    alert.triggers.length > 0 &&
    alert.triggers?.[0]?.type === "expiration" &&
    (alert.triggeringJournalEventType === "BioExamPrescribedJournalEvent" ||
      alert.triggeringJournalEventType === "MedicationPrescribedJournalEvent")
  )
    return "bio-exam-prescription";
  else if (
    alert.alertType === "journey" &&
    alert.subType === "medication-prescription" &&
    alert.triggers.length > 0 &&
    alert.triggers?.[0]?.type === "expiration" &&
    (alert.triggeringJournalEventType === "BioExamPrescribedJournalEvent" ||
      alert.triggeringJournalEventType === "MedicationPrescribedJournalEvent")
  )
    return "medication-prescription";
  else if (
    alert.alertType === "clinical" &&
    ["rch", "crohn", "ibd-disk"].includes(alert.subType) &&
    alert.triggers?.length > 0
  )
    return "mici-survey";
  else if (alert.alertType === "treatment-compliance")
    return "treatment-compliance";

  return undefined;
}

export function isOfComputedType(
  alert: HomePageAlertType,
  type: ComputedAlertType
): boolean {
  return computeAlertType(alert) === type;
}

export function isMrcStageChangealert(alert: HomePageAlertType) {
  return alert.alertType.startsWith("mrc-stage-change-");
}

export function tlsPrescriptionTrigger(
  alert: HomePageAlertType
): TlsPrescriptionTrigger {
  if (alert.triggers.length != 1 || alert.triggers[0]?.type != "expiration")
    throw new Error(
      `The alert '${alert.id}' does not have a TLS prescription expiration trigger`
    );

  return alert.triggers[0] as TlsPrescriptionTrigger;
}

export function prescriptionTrigger(
  alert: HomePageAlertType
): PrescriptionTrigger {
  if (alert.triggers.length != 1 || alert.triggers[0]?.type != "expiration")
    throw new Error(
      `The alert '${alert.id}' does not have a prescription expiration trigger`
    );

  return alert.triggers[0] as PrescriptionTrigger;
}

export function isJourneyForgetAlert(alert: HomePageAlertType) {
  return (
    alert.alertType == "journey" &&
    alert.triggers?.length > 0 &&
    alert.triggers?.[0]?.type === "forget"
  );
}
